module.exports = __webpack_public_path__ + "media/img/sms-807b4970d54799e0889fc13c9aaeb814.jpg";